import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import React from "react";
import { useMessageSelectedContext } from "~/components/common/chat/ChatPagesContainer";
import { ChatMessageArea } from "~/components/common/chat/messages/ChatMessageArea";
import { ChatPostArea } from "~/components/common/chat/post/ChatPostArea";
import { useMessages } from "~/hooks/vendors/deals/useMessages";
import { useDeals } from "~/hooks/vendors/useDeals";
import { useMessageSummaries } from "~/hooks/vendors/useMessageSummaries";
import { useSessions } from "~/hooks/vendors/useSessions";
import { getUnreadCount, getVendorMessageReceiver } from "~/models/Message";

type Props = DeepReadonly<{
	setIsDisabledUnreadButton: (value: boolean) => void;
}>;

/**
 * チャット画面のメッセージ一覧
 *
 * @for vendor
 * @constructor
 */
export function ChatMessagePaneBodyVendor({
	setIsDisabledUnreadButton
}: Props) {
	const { selectedSummary } = useMessageSelectedContext();
	const { data: session } = useSessions().index();
	const { mutate: mutateMessageSummaries } = useMessageSummaries().index();
	const { data: messages, mutate: mutateMessages } = useMessages().index(
		selectedSummary?.deal.id ?? null
	);
	const { data: deal, mutate: mutateDeal } = useDeals().show(
		selectedSummary?.deal.id ?? null
	);

	// const debounce = useDebounce(2000);
	React.useEffect((): void => {
		if (selectedSummary === null) {
			return;
		}
		// debounce(() => {
		mutateDeal?.().then();
		setIsDisabledUnreadButton(true);
		mutateMessages?.().then();
		if (messages && deal && session) {
			setIsDisabledUnreadButton(
				getUnreadCount(messages, getVendorMessageReceiver(deal, session)) > 0
			);
		}
		// });
	}, [
		selectedSummary,
		mutateMessages,
		mutateDeal,
		setIsDisabledUnreadButton,
		messages,
		deal,
		session
	]);
	const handleMutate = React.useCallback(async (): Promise<void> => {
		mutateDeal?.().then();
		mutateMessages?.().then();
		mutateMessageSummaries?.().then();
	}, [mutateMessages, mutateDeal, mutateMessageSummaries]);
	if (messages === null || deal === null || session === null) {
		return null;
	}
	return (
		<>
			<ChatMessageArea
				deal={deal}
				handleMutate={handleMutate}
				isOpen
				messages={messages}
				receiver={getVendorMessageReceiver(deal, session)}
			/>
			<ChatPostArea deal={deal} handleMutate={handleMutate} isVendor />
		</>
	);
}
